/**
 * File: viewProgramme.js
 * Project: educore
 * Created Date: 2019-03-22
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class ViewProgrammeController {
    // @ngInject
    constructor($scope, $rootScope, localStorageService, $state, MEDICALCONSTANT, authService) {

        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            getDate()
            getAssignedProgramme()
        }
        let schoolId = localStorageService.get('school_id')
        let academicYear = localStorageService.get('academic_year')
        let userId = localStorageService.get('user_id')
        $scope.programmeList = []

        function getDate() {
            authService.callAPI(MEDICALCONSTANT.API_GET_CURRENT_DATE, "GET", {}, function(response) {
                if (response && response.result && response.result.data) {
                    $scope.serverDate = response.result.data.data
                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        }

        function getAssignedProgramme() {
            let obj = {
                school_id: schoolId,
                academic_year: academicYear,
                user_id: userId
            }
            authService.callAPI(MEDICALCONSTANT.API_GET_ASSIGNED_PROGRAMME, "POST", obj, function(response) {
                if (response.result && response.result.data && response.result.data.data) {
                    if (response.result.data.data.length > 0) {
                        let resultData = response.result.data.data
                        _.each(resultData, function(pgm) {
                            pgm.my_comment = null
                            let feedbackExists = _.find(pgm.attendees, function(pgm) {
                                return pgm.user_id == userId
                            })
                            if ($scope.serverDate > pgm.programme_time) {
                                pgm.can_add_comment = true
                            }
                            if (feedbackExists) {
                                if (feedbackExists.feedback) {
                                    pgm.can_add_comment = false
                                    pgm.my_comment = feedbackExists.feedback
                                }
                            }
                        })
                        $scope.programmeList = resultData
                        _.defer(function() {
                            $scope.$apply();
                        });
                    }
                }
            })
        }
        $scope.addComment = (data) => { //adding comment by the invitee
            if (data.comment == '' || data.comment == null || data.comment == undefined) {
                toastr.error("Please enter comment")
            } else {
                let commentObj = {
                    user_id: userId,
                    comment: data.comment,
                    pgm_id: data._id
                }
                authService.callAPI(MEDICALCONSTANT.API_ADD_COMMENT, "POST", commentObj, function(response) {
                    if (response && response.result && response.result.data.data) {
                        console.log(response.result.data.data)
                        toastr.success("Comment added successfully!")
                        getAssignedProgramme()
                        _.defer(function() {
                            $scope.$apply();
                        });
                    } else {
                        toastr.error('Server Interpreted.Please try after some time.')
                    }
                })
            }
        }


        $scope.collapseHistory = function(expa) {
            $scope.viewReportData = [] //to view report of the particular pgm by index
            for (var i in $scope.programList) {
                if ($scope.programList[i] != expa) {
                    $scope.programList[i].expanded = false;
                }
            }
            expa.expanded = !expa.expanded;
        };
        $scope.viewReport = (data, index) => { // view rport
            if ($scope.viewReportData[index]) {
                $scope.viewReportData[index] = false
            } else {
                $scope.viewReportData[index] = true
            }
        }
        $scope.setFilePath = function(img) {
            let new_url = FILE_UPLOAD_URL + img
            return new_url
        }
        $scope.viewImage = (dataUrl) => {
            let useFullScreen = ($mdMedia('sm') || $mdMedia('xs'));
            $scope.imgurl = FILE_UPLOAD_URL + dataUrl
            $mdDialog.show({
                    templateUrl: viewImage,
                    clickOutsideToClose: true,
                    scope: $scope,
                    fullscreen: useFullScreen,
                    preserveScope: true
                })
                .then(function() {

                }, function() {
                    self.status = 'You cancelled the dialog.';
                })
            $scope.$watch(function() {
                return $mdMedia('xs') || $mdMedia('sm');
            }, function(wantsFullScreen) {
                $scope.customFullscreen = (wantsFullScreen === true);
            });

        }
        $scope.cancel = function() {
            $mdDialog.hide();
        };
    }
}
export default ViewProgrammeController



// WEBPACK FOOTER //
// ./src/app/medical/controllers/medicalProgramme/viewProgramme.js